import { ThemeUIStyleObject } from 'theme-ui';
import ArrowRichImageIcon from '~/assets/images/icons/arrow-rich-image-icon.svg';
import { ReactElement } from 'react';

export const getIconComponent = (iconComponentOption?: Queries.OptionalImageIcon): ReactElement | null => {
  switch (iconComponentOption) {
    case 'arrow':
      return <ArrowRichImageIcon />;
    case 'none':
    default:
      return null;
  }
};

export const getHoverEffectStyle = (hoverEffect: string): ThemeUIStyleObject => {
  switch (hoverEffect) {
    case 'default':
    default:
      return {
        ':after': {
          content: "''",
          position: 'absolute',
          height: '100%',
          width: '100%',
          transition: 'opacity 0.5s ease-in-out',
          background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.70) 100%)',
          opacity: [1, 0],
        },

        ':hover': {
          ':after': {
            opacity: 1,
          },
          color: 'white',
        },
      };
  }
};
